import commercialisationApi from '@/api/commercialisation.api'

const getDefaultState = () => {
  return {
    /**
     * Commercialisation globale (pseudo-graine "TOTAL")
     * [{
     *    "codeIdaRs3":"BT",
     *    "anneeRecolte":"2020",
     *    "quantiteVendueSansContratEnKg":0,
     *    "quantiteStockAVendreEnKg":1470,
     *    "quantiteContractualiseeEnKg":302920,
     *    "quantiteContractualiseeEchangeSemenceEnKg":0,
     *    "quantiteContractualiseeEchangeAlimentEnKg":0,
     *    "quantiteLivreeEnKg":304390,
     *    "quantiteLivreeSurContratEnKg":302920,
     *    "commercialisationGrainesRs1": [{
     *         "codeIdaRs1":"BLE",
     *         "codeIdaRs3":"BT",
     *          "anneeRecolte":"2020",
     *          "quantiteDepotVenteVendueSansContratEnKg":1470
     *    }]
     * }]
     */
    listeCommercialisationGraineRs3: []
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    listeCommercialisationGraineRs3 (state) {
      return state.listeCommercialisationGraineRs3
    }
  },

  mutations: {
    UPDATE_COMMERCIALISATION_RS3 (state, listeCommercialisationGraineRs3) {
      state.listeCommercialisationGraineRs3 = listeCommercialisationGraineRs3
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    fetchCommercialisation ({ commit, rootGetters }) {
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return commercialisationApi.fetchCommercialisation(username, anneeRecolte).then(result => {
        commit('UPDATE_COMMERCIALISATION_RS3', result)
        return result
      })
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
